<template>
    <v-card class="panelBlock" v-if="isShowTile && (showSubNetworksList || showRelatedCommunitiesList)">
        <!-- <status-overlay class="sub-network-overlay" :action="loadingAction"></status-overlay> -->

        <v-flex tag="h2"><span :title="communityInfo && communityInfo.name ? communityInfo.name : ''">{{communityInfo && communityInfo.name ? communityInfo.name : ''}}</span></v-flex>
        <v-tabs
            color="ypo_blue"
            slider-color="ypo_gold"
            class="network__tabs">
            <v-tab
                @click="getSubNetworks()"
                v-if="showSubNetworksList"
                data-qe-id="get_sub-networks">
                {{networkConstants.SUB_NETWORK}}
            </v-tab>
            <v-tab
                @click="getRelatedCommunities()"
                v-if="showRelatedCommunitiesList"
                data-qe-id="get_related-communities">
                {{ communityLinks }}
            </v-tab>

            <v-tab-item v-if="!isSubNetwork && subNetworkList.length > 0">
                <v-flex class="sub-network inner-scrollbar">
                    <v-flex v-for="(subNetwork, j) in subNetworkList" :key="j">
                        <router-link :to="{path : `/network/${subNetwork.communityId}` }"
                                     :data-qe-id="`sub-networks_${j}_link`"
                                     class="network_page_related_sub-network">
                            {{subNetwork && subNetwork.name ? subNetwork.name : ''}}
                        </router-link>
                    </v-flex>
                </v-flex>
            </v-tab-item>

            <v-tab-item v-if="relatedCommunitiesList.length > 0 || isCommunityAdmin">
                <v-flex class="network__tabs__drag-div inner-scrollbar" v-if="!isAddRecord">
                    <draggable
                        :list="relatedCommunitiesList"
                        :options="{animation:200,disabled: !canEditRelatedCommunities, onSort:changeOrder()}"
                        :move="onListItemMove">
                        <!-- <draggable :list="relatedCommunitiesList"> -->
                        <v-flex
                            v-for="(community,i) in relatedCommunitiesList"
                            :key="i"
                            class="network__tabs__drag-div__row">
                            <i class="fas fa-grip-vertical"></i>
                            <a @click="openLink(community)" class="network_page_related_community" data-qe-id="open_community_url_anchor">{{community.title}}</a>
                            <v-flex class="network__tabs__drag-div__actions" v-if="canEditRelatedCommunities && isCommunityAdmin">
                                <i class="fas fa-pencil-alt" v-if="isCommunityAdmin && canEditRelatedCommunities" @click="editRelatedCommunity(community.id)" :data-qe-id="`sub-networks_${i}-edit_link`" title="Edit">
                                </i>
                                <i class="fas fa-trash-alt" v-if="isCommunityAdmin && canEditRelatedCommunities" @click="deleteOpenDialog(community.id)" :data-qe-id="`sub-networks_${i}-delete_link`" title="Delete">
                                </i>
                            </v-flex>
                        </v-flex>
                    </draggable>

                    <v-flex
                        v-if="isCommunityAdmin && !isReordered"
                        text-xs-center
                        mt-2>
                        <v-btn
                            @click="addNewRelatedCommunity()"
                            data-qe-id="add-communities_btn"
                            class="primary_btn transparent">
                            <i class="fas fa-plus mr-2"></i>
                            {{ addCommunityText }}
                        </v-btn>
                    </v-flex>
                    <v-flex
                        text-xs-center
                        class="network__tabs__delete__dailog"
                        v-if="deleteDialog">
                        <v-flex tag="p">Are you sure you want to delete?</v-flex>
                        <v-flex>
                            <v-btn
                                class="primary_btn transparent v-btn--flat theme--light small"
                                data-qe-id="cancel_dialog_btn"
                                @click="deleteDialog = false">Cancel</v-btn>
                            <v-btn
                                class="primary_btn theme--dark small"
                                data-qe-id="save_dialog_btn"
                                @click="deleteRelatedCommunity()">Ok</v-btn>
                        </v-flex>

                    </v-flex>
                </v-flex>
                <v-flex class="addeditcommunity pa-3" v-if="isAddRecord">
                    <v-form v-model="fieldsValid">
                        <v-text-field
                            v-model="newCommunity.title"
                            :rules="titleRules"
                            :disabled="isValRelated"
                            autofocus
                            :placeholder="networkConstants.TITLE_PLACEHOLDER"></v-text-field>
                        <v-text-field
                            v-model="newCommunity.url"
                            :rules="urlRules"
                            :disabled="isValRelated"
                            :placeholder="networkConstants.LINK_PLACEHOLDER"></v-text-field>
                    </v-form>
                    <v-layout row wrap>
                        <v-flex xs3>
                            <v-btn
                                @click="isAddRecord=false"
                                data-qe-id="close_dialog_btn"
                                class="primary_btn transparent small">{{appCommonConstants.CANCEL}}</v-btn>
                        </v-flex>
                        <v-flex xs9 text-xs-right>
                            <v-btn
                                v-if="!isEditRecord"
                                @click="saveRelatedCommunity()"
                                class="primary_btn small"
                                data-qe-id="save_dialog_btn"
                                :loading="isProcessing"
                                :disabled="!formValid || isValRelated">{{appCommonConstants.SAVE}}</v-btn>
                            <v-btn
                                v-if="isEditRecord"
                                @click="updateRelatedCommunityRecord()"
                                class="primary_btn small"
                                data-qe-id="update_dialog_btn"
                                :disabled="!formValid || isValRelated">{{appCommonConstants.UPDATE}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex class="addeditcommunity pa-3" v-if="isReordered">
                    <v-layout row wrap>
                        <v-flex xs3>
                            <v-btn
                                @click="resetOrder()"
                                data-qe-id="cancel_dialog_btn"
                                class="primary_btn transparent small">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                        </v-flex>
                        <v-flex xs9 text-xs-right>
                            <v-btn
                                @click="saveReorderCommunity()"
                                data-qe-id="save_dialog_btn"
                                class="primary_btn small">
                                {{appCommonConstants.SAVE}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
    import { mapGetters, mapActions, mapState } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from '../../store/storeGetters.constant';
    import draggable from 'vuedraggable';
    import { networkConstants } from "../../components/ChapterPage/communityCommon.constant";
    import { routerNames, appCommonConstants } from "../appCommon.constants";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { gaDataLayerEvent } from "@/plugins/analytics";

    export default {
        name: 'RelatedNetworks',
        components: {
            StatusOverlay,
            draggable,

        },
        created() {
            if (this.canViewSubNetworks) {
                this.getSubNetworksList();
            }
            this.getRelatedCommunitiesList().then(() => {
                this.originalOrder = { ...this.relatedCommunitiesList };
            });
            },
        props: {
            canViewSubNetworks: {
                type: Boolean,
                required: true,
            },
        },
        data: () => ({
            originalOrder: [],
            isReorder: false,
            isAddRecord: false,
            isProcessing: false,
            deleteDialog: false,
            isEditRecord: false,
            isReordered: false,
            networkConstants,
            appCommonConstants,
            routerNames,
            newCommunity: {
                url: '',
                title: '',
                order: '',
            },
            networkId: '',
            fieldsValid: false,
            isValRelated: false,
            isDeleteCommunityId: '',
            titleRules: [
                v => !!v || networkConstants.errors.TITLE_IS_REQUIRED,
            ],
            urlRules: [
                v => !v || !!v.match(/(\S+\.[^/\s]+(\/\S+|\/|))/g) || networkConstants.errors.URL_LINK_IS_REQUIRED,
            ],
        }),

        methods: {
            ...mapActions({
                getSubNetworksList: `network/${storeAction.getSubNetworksData}`,
                getRelatedCommunitiesList: `network/${storeAction.getRelatedCommunities}`,
                createNewCommunity: `network/${storeAction.createRelatedCommunity}`,
                deleteCommunity: `network/${storeAction.deleteRelatedCommunity}`,
                updateCommunity: `network/${storeAction.updateRelatedCommunity}`,
                reorderedRelatedCommunities: `network/${storeAction.saveReorderedRelatedCommunities}`,
            }),
            resetOrder() {
                this.relatedCommunitiesList.forEach((ele) => {
                    ele.order = this.originalOrder.find(item => item.id === ele.id).order;
                });
                this.relatedCommunitiesList.sort((e1, e2) => {
                    return e1.order - e2.order;
                });
                this.isReordered = false;
            },
            saveReorderCommunity() {
                this.reorderedRelatedCommunities(this.relatedCommunitiesList).then(() => {
                    this.originalOrder = this.relatedCommunitiesList.map(a => Object.assign({}, a));
                    this.isReordered = false;
                });
            },
            onListItemMove() {
                this.isReordered = true;
            },
            changeOrder() {
                if (this.isReordered && this.relatedCommunitiesList) {
                    this.relatedCommunitiesList.map((element, index) => {
                        element.order = index + 1;
                        return element;
                    });
                }
            },
            getSubNetworks() {
                return this.subNetworkList;
            },
            getRelatedCommunities() {
                return this.relatedCommunitiesList;
            },
            openLink(community) {
                gaDataLayerEvent(gtmEventName.C_Network_Related_Community, `Community_${community.id} | ${community.title}`);
                window.open(community.url, '_blank');
            },
            saveRelatedCommunity() {
                this.isProcessing = true;
                if (!this.newCommunity.url.includes('http')) {
                    this.newCommunity.url = `http://${this.newCommunity.url}`;
                }
                this.createNewCommunity(JSON.parse(JSON.stringify(this.newCommunity))).then(() => {
                    this.newCommunity.url = '';
                    this.newCommunity.title = '';
                    this.isAddRecord = false;
                    this.isEditRecord = false;
                    this.isProcessing = false;
                });
            },
            async updateRelatedCommunityRecord() {
                await this.updateCommunity({ newCommunity: JSON.parse(JSON.stringify(this.newCommunity)), communityId: this.networkId });
                this.newCommunity.url = '';
                this.newCommunity.title = '';
                this.newCommunity.order = '';
                this.isAddRecord = false;
                this.isEditRecord = false;
            },
            async deleteRelatedCommunity() {
                await this.deleteCommunity(this.isDeleteCommunityId);
                this.deleteDialog = false;
            },
            editRelatedCommunity(relatedCommunityId) {
                const relatedCommunity = this.relatedCommunitiesList.find(item => item.id === relatedCommunityId);
                this.newCommunity.title = relatedCommunity.title;
                this.newCommunity.url = relatedCommunity.url;
                this.newCommunity.order = relatedCommunity.order;
                this.isAddRecord = true;
                this.isEditRecord = true;
                this.networkId = relatedCommunityId;
            },
            addNewRelatedCommunity() {
                this.isAddRecord = true;
                this.isEditRecord = false;
                this.newCommunity.title = '';
                this.newCommunity.url = '';
                this.newCommunity.order = this.relatedCommunitiesList.length;
            },
            deleteOpenDialog(networkId) {
                this.deleteDialog = true;
                this.isDeleteCommunityId = networkId;
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                subNetworkList: `network/${storeGetters.subNetworkList}`,
                relatedCommunitiesList: `network/${storeGetters.relatedCommunitiesList}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                canEditRelatedCommunities: `network/${storeGetters.canEditRelatedCommunities}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
            formValid() {
                return this.fieldsValid && (this.newCommunity.title && this.newCommunity.url);
            },
            isSubNetwork() {
                return (this.subNetworkList && this.subNetworkList.length > 0) ? this.subNetworkList.some(o => o.communityId === this.$route.params.communityId) : false;
            },
            showSubNetworksList() {
                return !this.isSubNetwork && this.subNetworkList.length > 0 && !this.isGroupPage;
            },
            showRelatedCommunitiesList() {
                return this.relatedCommunitiesList.length > 0 || this.isCommunityAdmin || this.isGroupPage;
            },
            isShowTile() {
                return (this.subNetworkList.length > 0 || this.relatedCommunitiesList.length > 0 || this.isCommunityAdmin);
            },
            // loadingAction() {
            //     return this.actions[storeAction.getSubNetworksData] || this.actions[storeAction.getRelatedCommunitiesList] ? this.actions[storeAction.getSubNetworksData] : ;
            // },
            isGroupPage() {
                return this.$route.name === this.routerNames.GROUP;
            },
            communityLinks() {
                return this.$route.name === routerNames.COMMUNITIES 
                ? communitiesConstants.COMMUNITY_QUICK_LINKS 
                : networkConstants.RELATED_COMMUNITIES;
            },
            addCommunityText() {
                return this.$route.name === routerNames.COMMUNITIES 
                ? communitiesConstants.ADD_COMMUNITIES_QUICK_LINKS 
                : networkConstants.ADD_COMMUNITIES;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .network__tabs {
        .v-tabs__item {
            color: $white;

            i {
                color: $white;
            }
        }

        &__drag-div {
            padding: 10px;
            max-height: 250px;
            overflow-y: auto;

            &__row {
                position: relative;
                border-bottom: 1px solid $ypo-medium-gray;
                padding: 10px 60px 10px 30px;
                transition: 0.3s ease all;

                a {
                    text-decoration: none;
                    font-size: 14px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: block;
                    overflow: hidden;

                }

                .fa-arrow-right {
                    position: absolute;
                    right: 5px;
                    top: 12px;
                    font-size: 18px;
                    color: $ypo-cta;
                }

                .fa-grip-vertical {
                    position: absolute;
                    left: 5px;
                    top: 15px;
                    color: $ypo-cta;
                    cursor: move;

                }

                &:hover {
                    .fa-arrow-right {
                        opacity: 0;
                    }

                    .network__tabs__drag-div__actions {
                        opacity: 1;
                        visibility: visible;

                    }

                }

            }

            &__actions {
                position: absolute;
                opacity: 0;
                right: 6px;
                top: 10px;
                transition: 0.3s ease all;
                visibility: hidden;

                i {
                    margin-left: 10px;
                    cursor: pointer;
                    color: $ypo-cta;
                }
            }

        }

        &__delete__dailog {
            background-color: rgba($white, 0.9);
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            padding: 15px;
            border-radius: 3px;
            height: 100%;

            h4 {
                position: relative;
                padding-right: 23px;

                .close-btn {
                    position: absolute;
                    right: 0;
                    top: -7px;
                    margin: 0;
                }
            }

            p {
                margin: 20px 0;
            }

        }

        .sub-network {
            padding: 10px;

            a {
                text-decoration: none;
                color: $ypo-title-blue;
                display: inline-block;
                margin-bottom: 10px;

                &:hover {
                    text-decoration: underline;
                }
            }

            &.inner-scrollbar {
                max-height: 25px;
                overflow-y: auto;
                min-height: 200px;
            }
        }
    }

    .sub-network-overlay {
        margin-top: 90px;
    }
</style>
